import i18n from '~/i18n/locale';
import '../lib/validators/iban';

const scope = { scope: 'pay.js.validations' };

function presenceIf(optional, message = i18n.t('presence', scope)) {
  return optional ? {} : { presence: { message, allowEmpty: false } };
}

export default function getValidations(settings = {}) {
  return {
    accountno: {
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      },
      iban: {
        message: i18n.t('invalid', scope)
      }
    },
    address: {
      ...presenceIf(settings.optional)
    },
    afterpayAgreement: {
      inclusion: {
        message: i18n.t('marketing.agreement.inclusion', scope),
        within: [true]
      }
    },
    afterpayPhoneno: {
      format: {
        message: i18n.t('invalid', scope),
        pattern: /^[0-9 \\/\-+().]*$/
      },
      length: {
        minimum: 8,
        message: i18n.t('too_short', { ...scope, count: 8 }),
      },
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      }
    },
    city: {
      ...presenceIf(settings.optional)
    },
    cocNumber: {
      ...presenceIf(settings.optional)
    },
    companyName: {
      ...presenceIf(settings.optional)
    },
    customAgreement: {
      inclusion: {
        message: i18n.t('marketing.agreement.inclusion', scope),
        within: [true]
      }
    },
    day: {
      format: {
        message: i18n.t('invalid', scope),
        pattern: /^0[1-9]|1\d|2\d|3[01]$/
      },
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      }
    },
    email: {
      email: {
        message: i18n.t('invalid', scope)
      },
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      }
    },
    firstname: {
      ...presenceIf(settings.optional)
    },
    initials: {
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      }
    },
    gender: {
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      }
    },
    mobile: {
      format: {
        message: i18n.t('invalid', scope),
        pattern: /^[0-9 \\/\-+().]+$/
      },
      ...presenceIf(settings.optional)
    },
    month: {
      format: {
        message: i18n.t('invalid', scope),
        pattern: /^0[1-9]|1[0-2]$/
      },
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      }
    },
    name: {
      ...presenceIf(settings.optional)
    },
    password: {
      ...presenceIf(settings.optional)
    },
    passwordConfirmation: {
      equality: {
        attribute: 'password',
        message: i18n.t('equal', scope),
      },
      ...presenceIf(settings.optional)
    },
    phoneno: {
      format: {
        message: i18n.t('invalid', scope),
        pattern: /^[0-9 \\/\-+().]*$/,
        allowEmpty: true
      },
      ...presenceIf(settings.optional)
    },
    remarks: {
      ...presenceIf(settings.optional)
    },
    sepaAgreement: {
      inclusion: {
        message: i18n.t('marketing.agreement.inclusion', scope),
        within: [true]
      }
    },
    sepaInstallmentsAgreement: {
      inclusion: {
        message: i18n.t('marketing.agreement.inclusion', scope),
        within: [true]
      }
    },
    vatno: {
      format: {
        message: i18n.t('invalid', scope),
        pattern: /^$|[A-Z]{2}[0-9A-Za-z+*.]{2,12}/i
      },
      ...presenceIf(settings.optional)
    },
    year: {
      format: {
        message: i18n.t('invalid', scope),
        pattern: /(19|20)\d{2}$/
      },
      presence: {
        message: i18n.t('presence', scope),
        allowEmpty: false
      }
    },
    zipcode: {
      ...presenceIf(settings.optional)
    },
  };
};
